"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ITOP_CONTACT_NOTIFY = exports.ITOP_CONTACT_STATUS = void 0;
exports.ITOP_CONTACT_STATUS = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
};
exports.ITOP_CONTACT_NOTIFY = {
    YES: 'yes',
    NO: 'no',
};
